import { useEffect, useState } from "react";
import { ExternalLink } from "lucide-react";
import { restaurantInfo } from "../mock";

/**
 * Sticky floating Order Online CTA (visible on mobile/small screens after user
 * scrolls past the hero). Nudges the user toward ordering — non-invasive.
 */
export default function FloatingOrderCTA() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 500);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <a
      href={restaurantInfo.externalLinks.orderOnline}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Order Online"
      className={`sm:hidden fixed z-40 bottom-5 right-5 inline-flex items-center gap-2 bg-brand text-cream px-5 py-3.5 rounded-full font-medium text-sm shadow-2xl transition-all duration-500 ${
        show ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6 pointer-events-none"
      }`}
    >
      <span className="relative flex h-2.5 w-2.5">
        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-cream/70 opacity-75" />
        <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-cream" />
      </span>
      Order Online
      <ExternalLink className="w-3.5 h-3.5" />
    </a>
  );
}
